import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CutsceneTemplat from '../Components/Layout/CutsceneTemplate';

import Commander from '../Assets/Imgs/Commander.png';
import Mike from '../Assets/Imgs/Mike.png';
import Btn from '../Components/Common/Btn';

import Pause from '../Assets/Icons/Pause.svg'
import PauseMenu from '../Components/Layout/PauseMenu';

const FixedCutscene = () => {

    const [currentLine, setCurrentLine] = useState(0)
    const [isPaused, setIsPaused] = useState(false);

    const navigate = useNavigate();

    const dialogue = [
        {
            img: Mike, text: 'Perfect, This is gonna come in handy!', DName: 'Private Mike'
        },
    ]

    const handleNextDialogue = () => {
        if (currentLine < dialogue.length - 1) {
            setCurrentLine(prevStep => prevStep + 1);
        } else {
            navigate('/approach');
        }
    };

    const currentDialogue = dialogue[currentLine];
    console.log(dialogue[0])

    return ( 
        <main className='FixedCutsceneMain'>

            <Btn BtnIcon={Pause} BtnStyle="PauseBtn" onClick={() => setIsPaused(true)}/>
            
            <CutsceneTemplat TemplateClass='FixTemplate' DialogueImg={currentDialogue.img} DialogueName={currentDialogue.DName} DialogueP={currentDialogue.text} NextBtnChange={handleNextDialogue}/>

            {isPaused && <PauseMenu ResumeClick={()=>setIsPaused(false)}/>}
        </main>
     );
}
 
export default FixedCutscene;